import React from 'react';
import { formStyles } from '../../constants/SiteVariables';
import { ErrorMessage, Field } from 'formik';

export default function StickyInput({
  error,
  id,
  placeholder,
  options,
  disclaimer
}) {
  return (
    <div className="select is-fullwidth sticky-placeholder">
      <div className="control">
        <Field as="select"
          className={formStyles.error(error)}
          children={options.map(o => <option key={o[1]} value={o[1]}>{o[0]}</option>)}
          id={id}
          name={id} />
        <label className="placeholder" htmlFor={id}>{placeholder}</label>
        {disclaimer && disclaimer}
        <ErrorMessage name={id} component="div" className={formStyles.validation} />
      </div>
    </div>
  );
}
